import {Component, Input, OnInit} from '@angular/core';
import {ConfService} from '../conf.service';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
declare let $;
@Component({
  selector: 'app-end-points',
  templateUrl: './end-points.component.html',
  styleUrls: ['./end-points.component.scss']
})
export class EndPointsComponent implements OnInit {

  apiExecutor: any;
  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');
  @Input() entity: string;
  @Input() version: string;
  @Input() type: string;
  @Input() url: string;
  @Input() ispublished = false;


  partnerKey = localStorage.getItem('partnerKey');
  apiKey = localStorage.getItem('apikey');

  constructor(private confPost: ConfService,
              public platform: LeftpanelComponent) { }

  ngOnInit() {
    if (this.partner && this.account && this.entity && this.version) {
      if (this.type && this.type === 'dataaccess') {
        this.confPost.getApiExecutorsByPartnerAccountEntityVersion(this.partner, this.account, this.entity, this.version).subscribe(response => {
          this.apiExecutor = response;
        }, error => {
          this.platform.openSnackBar('Error in retrieving APIs. Please try again', 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        });
      } else {
        this.confPost.getApiExecutorByPartnerAccountEntityVersion(this.partner, this.account, this.entity, this.version).subscribe(response => {
          this.apiExecutor = response;
        }, error => {
          this.platform.openSnackBar('Error in retrieving APIs. Please try again', 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        });
      }

    } else {
      this.platform.openSnackBar('Error while retrieving API end points. Please check your API settings', 'Error', {
        duration: 10000
      });
    }
  }
  copyMessage(val) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = $(val).text();
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    alert('CURL command copied to clipboard');
  }
}
